/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrbackground1Inputs */

const en_qrbackground1 = /** @type {(inputs: Qrbackground1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background`)
};

const de_qrbackground1 = /** @type {(inputs: Qrbackground1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrund`)
};

/**
* | output |
* | --- |
* | "Background" |
*
* @param {Qrbackground1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrbackground1 = /** @type {((inputs?: Qrbackground1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrbackground1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrbackground1(inputs)
	return de_qrbackground1(inputs)
});
export { qrbackground1 as "qrBackground" }